// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsent_root__D6h3X"};